import { Security2 } from "@assets/svg";
import { Button } from "@components/Button";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { BodySmall, Caption } from "@components/Typography";
import { Flow, Routes } from "@ctypes";
import { useModal, useNavigateToStep, useTheme, useUser } from "@hooks";
import { i18n, Translations } from "@i18n";
import { Intercom } from "@services";
import {
  AccountPaused,
  ContributionFailed,
  RelinkFundingSource,
  ResumeContributions,
} from "./content";
import { Container } from "./styledComponents";
import { useStyles } from "./styles";
import { BankRelinkModalProps, BankRelinkModalVariant } from "./types";

export const BankRelinkModal = ({ variant }: BankRelinkModalProps) => {
  const styles = useStyles();
  const { theme } = useTheme();
  const { disconnectedAccounts } = useUser();
  const { dismiss } = useModal();
  const navigate = useNavigateToStep();

  const isAccountPaused = variant === BankRelinkModalVariant.AccountPaused;

  const handleRelink = () => {
    navigate(Routes.BankLinking, { state: {
      bankLinkId: disconnectedAccounts?.[0]?.id,
      flow: Flow.Relinking,
    } });
    dismiss();
  };

  const handleContactSupport = () => {
    Intercom.showChat();
    dismiss();
  };

  const body = (() => {
    switch (variant) {
      case BankRelinkModalVariant.ContributionFailed:
        return <ContributionFailed />;
      case BankRelinkModalVariant.RelinkFundingSource:
        return <RelinkFundingSource />;
      case BankRelinkModalVariant.ResumeContributions:
        return <ResumeContributions />;
      case BankRelinkModalVariant.AccountPaused:
        return <AccountPaused />;
    }
  })();

  return (
    <Container>
      {body}

      <Button
        title={i18n.t(
          isAccountPaused
            ? Translations.BankRelinkModalAccountPausedPrimaryCTA
            : Translations.BankRelinkModalPrimaryCTA,
        )}
        onClick={isAccountPaused ? handleContactSupport : handleRelink}
      />

      <Spacing size={SpacingSizes.M} />

      <div style={styles.protection}>
        <Security2 size={16} fill={theme.text.tertiary} />
        <Caption style={styles.protectionText}>
          {i18n.t(Translations.BankRelinkModalProtection)}
        </Caption>
      </div>

      <div onClick={handleContactSupport} role="button" tabIndex={0}>
        <BodySmall style={styles.supportCtaText}>
          {i18n.t(Translations.BankRelinkModalSupportCTA)}
        </BodySmall>
      </div>
    </Container>
  );
};
